import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <section className="py-2 my-header-bg fixed-bottom">
        <div className="container">
          <div className="d-flex justify-content-between">
            <div>
              <h5 class="mb-0 fs-4 fw-normal lh-sm text-success">
                Discover your moments
              </h5>
              <h2 class="fs-4 text-white fw-normal ls-sm lh-1">
                From over 104 million memories
              </h2>
            </div>

            <div>
              <Link
                to="/search"
                className="btn bg-gold text-dark w-auto px-5 rounded-pill fw-semibold"
              >
                Find Me
              </Link>
              <a
                href="https://api.whatsapp.com/send?phone=919619359359&text=Hi"
                target="_blank"
                class="btn btn-icon btn-success rounded-circle d-none d-md-inline-flex ms-2"
              >
                <i class="bi bi-whatsapp fs-4 align-middle"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer class="footer py-8">
        <div class="container pb-1">
          <div class="row pb-7">
            <div class="col-xl-3 col-md-3 col-6">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fs-4 text-white">Company</span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <Link to="/" class="nav-link">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/features" class="nav-link">
                      About Visualaey
                    </Link>
                  </li>
                  <li>
                    <Link to="/features" class="nav-link">
                      Features
                    </Link>
                  </li>
                  <li>
                    <Link to="/pricing" class="nav-link">
                      Pricing
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" class="nav-link">
                      Contact us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-2 col-md-3 col-6">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fs-4 text-white">Community</span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <Link to="/book-demo" class="nav-link">
                      Book a Demo
                    </Link>
                  </li>
                  <li>
                    <Link to="/login" class="nav-link">
                      Login
                    </Link>
                  </li>
                  <li>
                    <Link to="/signup" class="nav-link">
                      Sign Up
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-3 col-md-3 col-6 mt-lg-0 mt-4">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fs-4 text-white">Policies</span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <Link to="/terms" class="nav-link">
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/payment-policy" class="nav-link">
                      Payment Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy" class="nav-link">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/disclaimer" class="nav-link">
                      Disclaimer
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12 col-md-6 col-12 mt-lg-0 mt-4">
              <div class="d-flex flex-column gap-4">
                <span class="text-white-stable fs-4 text-white">
                  Get the App
                </span>
                <div className="d-flex gap-1">
                  <img src="/assets/images/btn-appstore.svg" width="150" />
                  <img src="/assets/images/btn-g-play.svg" width="150" />
                </div>
                <p class="mb-0 fw-light">
                  <i className="bi bi-telephone"></i> +91 9619359359
                  <br />
                  <i className="bi bi-envelope"></i> support@visualaey.com
                </p>
              </div>
            </div>
          </div>
          <div class="row align-items-center g-0 border-top border-gray-800 py-5 flex-column gap-1 flex-lg-row gap-lg-0">
            <div class="col-lg-6 col-12 text-center text-md-start lh-sm">
              <img src="/assets/images/logo.png" width="140" className="mb-2" />
              <br />
              <span>Visualez Mediaa Works Private Limited</span>
              <br />
              <span>CIN : U98200MH2024PTC425556</span>
            </div>
            <div class="col-12 col-lg-6">
              <div class="justify-content-center justify-content-md-start justify-content-lg-end">
                <p className="fs-8 lh-sm m-0 fw-light text-lg-start text-center">
                  Visualaey is an <u>AI-powered</u>, event photo sharing
                  platform, built on a secure cloud native foundation, that
                  transforms how memories are discovered and shared. Our clever
                  face matching technology instantly finds every photo you're in
                  and delivers them right to you. No tagging, no searching, just
                  seamless access.
                </p>
              </div>
            </div>
          </div>
          <div class="row align-items-center g-0 border-top border-gray-800 py-3 flex-column gap-1 flex-lg-row gap-lg-0 mb-3">
            <div class="col-lg-6 col-12 text-center text-md-start">
              <span>Copyright © 2026 Visualaey®</span>
            </div>
            <div class="col-12 col-lg-6">
              <nav class="nav nav-footer justify-content-center justify-content-md-start justify-content-lg-end">
                <Link to="/tnc" class="nav-link active">
                  Terms of Use
                </Link>
                <Link to="/privacy-policy" class="nav-link">
                  Privacy Policy
                </Link>
              </nav>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
